import React, { useEffect } from 'react';

import { Loader } from '~/components/blocks';
import { ClientCertError } from '~/components/partials/ClientCertVertification/ClientCertError';

import { useClientCertVerification } from './use-client_cert_verification';

type Props = {
  children: React.ReactNode;
};

export const ClientCertVerification: React.FC<Props> = (props) => {
  const { status, redirectUrl, loaded } = useClientCertVerification();
  const shouldRedirect =
    loaded && redirectUrl && (status === 'redirect_to_app' || status === 'redirect_to_s');

  useEffect(() => {
    if (shouldRedirect) {
      window.location.href = redirectUrl;
    }
  }, [loaded, status, redirectUrl, shouldRedirect]);

  if (!loaded || shouldRedirect) {
    return <Loader open />;
  }

  if (status === 'ng') {
    return <ClientCertError redirectUrl={redirectUrl} />;
  }

  return <>{props.children}</>;
};
